import { useContext } from 'react';

import { media } from 'context';
import { Button, Img, Layout, Modal, Text } from 'ds';

interface ServicesModalStepperProps {
  isVisible: boolean;
  onClose: () => void;
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

const ServicesModalStepper = ({ isVisible, onClose, currentStep, setCurrentStep }: ServicesModalStepperProps) => {
  const { isMobile } = useContext(media);
  const modalSteps = [
    {
      title: 'AI office assistant',
      description:
        'Have 24/7 support for instant vendor coordination and service requests. Never chase a service provider again.',
      imageSrc: isMobile ? 'ai-assistant-stepper-mobile_Sg9ii-c4G.png' : 'ai-assistant-stepper-desktop_jnbZE4_OP.png'
    },
    {
      title: 'Furniture & design',
      description:
        'Furniture sets handpicked by our workplace designers, optimized for productivity. From generating layouts to installation, we’ll handle it all. Purchase options available through the Codi shop.',
      imageSrc: isMobile
        ? 'furniture-design-stepper-mobile_aLM7we4Qp.png?updatedAt=1744074484973'
        : 'furniture-design-stepper-desktop_shgVTjcMs.png?updatedAt=1744069774686'
    },
    {
      title: 'Internet & IT',
      description:
        'IT, internet, room booking systems, and A/V services and equipment with professional setup and ongoing support.',
      imageSrc: isMobile
        ? 'internet-it-stepper-mobile_Zg_mpqILA.png?updatedAt=1744074671987'
        : 'internet-and-it-stepper-desktop_mcNzWp_Hpd.png?updatedAt=1744069822725'
    },
    {
      title: 'Restocking',
      description:
        'Delight your team with curated refreshments & supplies, restocked automatically. Items are unboxed and neatly placed in your pantry, fridge, restrooms, and cabinets - saving you precious hours for eah order.',
      imageSrc: isMobile
        ? 'supply-restocking-stepper-mobile_JjSzpq_03.png?updatedAt=1744074808398'
        : 'Supply-and-restocking-stepper-desktop_vPX-N7cW0.png?updatedAt=1744069870806'
    },
    {
      title: 'Cleaning',
      description:
        'Book recurring or one-off professional cleaning services instantly. Choose between light or deep cleaning. Managed through the Codi portal with established cleaning guidelines and photo verification.',
      imageSrc: isMobile
        ? 'cleaning-stepper-mobile_IptRMIfPb.png?updatedAt=1744074973598'
        : 'cleaning-stepper-desktop__ULzKNftc.png?updatedAt=1744073846712'
    },
    {
      title: 'Vendor network with exclusive discounts',
      description:
        'From repairs to maintenance, access our trusted network of service providers for all your office needs - and save thousands of dollars! ',
      imageSrc: 'vendor-network-stepper-desktop_QOKwObA77.png?updatedAt=1744070301125'
    }
  ];

  const footer = (
    <Layout flex justify="space-between" paddingBottom={8} paddingX={isMobile ? undefined : 24}>
      <Button
        type="secondaryOutline"
        size="sm"
        text="Back"
        onClick={() => setCurrentStep(currentStep === 0 ? modalSteps.length - 1 : currentStep - 1)}
      ></Button>
      <Button
        type="primary"
        size="sm"
        text="Next"
        onClick={() => setCurrentStep(currentStep === modalSteps.length - 1 ? 0 : currentStep + 1)}
      ></Button>
    </Layout>
  );
  return (
    <Modal
      width={500}
      isVisible={isVisible}
      bottomSheetIsRounded={isMobile ? true : undefined}
      onClose={onClose}
      footer={footer}
      showCloseButton={isMobile ? true : false}
      paddingTop={0}
      paddingBottom={0}
      paddingX={0}
      hasFooterBorder={false}
    >
      <Layout flex direction="column" height="100%">
        <Layout width={isMobile ? '100%' : 500} height={isMobile ? 320 : 224} maxHeight={isMobile ? 320 : 224}>
          <Img
            alt="AI office assistant"
            srcKey={modalSteps[currentStep].imageSrc}
            width={isMobile ? 1170 : 1500}
            height={isMobile ? 960 : 672}
            folder="ux"
            style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12, maxHeight: isMobile ? 320 : 224 }}
          />
        </Layout>
        <Layout flex direction="column" gap={16} paddingY={32} paddingX={36} height={194}>
          <Layout flex direction="column" gap={4}>
            <Text size="overline-sm" color="gray-700">
              {currentStep + 1} / {modalSteps.length} SERVICES
            </Text>
            <Text size="headline-md">{modalSteps[currentStep].title}</Text>
          </Layout>
          <Text size={isMobile ? 'body-md' : 'body-sm'} color="gray-700">
            {modalSteps[currentStep].description}
          </Text>
        </Layout>
      </Layout>
    </Modal>
  );
};

export default ServicesModalStepper;
